import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag sänka alkoholpriserna hur mycket jag vill?";
const SHORT_ANSWER = "Inom rimliga gränser – ja. Men priserna får inte uppmana till överkonsumtion och måste hålla 'måttfullhet'.";

export const Route = createFileRoute("/fraga/vad-galler-for-prissattning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag sänka alkoholpriserna hur mycket jag vill" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Extrema rabattformer (3 för 1, fritt påfyllning) bedöms strida mot 7 kap. Praxis varierar och kommunen kan ge anmärkning vid uppenbart oansvariga kampanjer."}
      source={{ label: "Konsumentverket – Marknadsföring av alkohol", href: "https://www.konsumentverket.se/for-foretag/marknadsforing/marknadsforing-av-alkohol/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Alkoholprissättning och kampanjer" }}
      related={[{"to": "/fraga/far-jag-anvanda-personalrabatt", "label": "Får personalen få alkohol gratis eller till rabatt?"}, {"to": "/fraga/vad-ar-egenkontrollprogram", "label": "Vad är ett egenkontrollprogram?"}, {"to": "/fraga/far-jag-erbjuda-fri-alkohol-som-kampanj", "label": "Får jag bjuda gäster på alkohol som marknadsföring?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag sänka alkoholpriserna hur mycket jag vill?" },
      { name: "description", content: "Inom rimliga gränser – ja. Men priserna får inte uppmana till överkonsumtion och måste hålla 'måttfullhet'." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-for-prissattning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-for-prissattning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-for-prissattning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag sänka alkoholpriserna hur mycket jag vill", url: "https://alkoholprovet.se/fraga/vad-galler-for-prissattning" },
      ]),
    ],
  }),
});
